import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-microfrontend-error',
  templateUrl: './microfrontend-error.component.html',
  styleUrls: ['./microfrontend-error.component.scss']
})
export class MicrofrontendErrorComponent {
  @Input() errorCode: string;
}
